import { createSelector } from 'reselect';
// Import state types.
import {
	AppState,
	PossibleProducerAgentsState,
} from '@app/redux/states';
// Import props.
import {
	PossibleProducerAgentsProps,
} from '@app/props';
// Import api models.
import {
	PossibleProducerAgent,
} from '@app/models/api';
// Import base selectors.
import {
	getAppState,
} from '@app/redux/selectors/base';
// Import selectors.
import {
	makeGetPolicyProducerAgencyIdSelector,
} from '@app/redux/selectors';

// Fetches the possible producer agents state.
const getPossibleProducerAgentsState = (state: AppState, props: PossibleProducerAgentsProps): PossibleProducerAgentsState | undefined => {
	return state.possibleProducerAgents[props.producerAgencyId];
}

// Get Possible Producer Agents State By Policy Producer Agency Id Selector.
const makeGetPossibleProducerAgentsStateByPolicyProducerAgencyIdSelector = () => createSelector(
	[getAppState, makeGetPolicyProducerAgencyIdSelector()],
	(appState: AppState, policyProducerAgencyId: number | undefined): PossibleProducerAgentsState | undefined => {
		return policyProducerAgencyId !== undefined
			? appState.possibleProducerAgents[policyProducerAgencyId]
			: undefined;
	}
);

// Get Possible Producer Agents Selector.
const makeGetPossibleProducerAgentsSelector = () => createSelector(
	[getPossibleProducerAgentsState],
	(possibleProducerAgentsState: PossibleProducerAgentsState | undefined): PossibleProducerAgent[] => {
		return possibleProducerAgentsState?.possibleProducerAgents ?? [];
	}
);

// Get Possible Producer Agents By Policy Producer Agency Id Selector.
const makeGetPossibleProducerAgentsByPolicyProducerAgencyIdSelector = () => createSelector(
	[makeGetPossibleProducerAgentsStateByPolicyProducerAgencyIdSelector()],
	(possibleProducerAgentsState: PossibleProducerAgentsState | undefined): PossibleProducerAgent[] => {
		return possibleProducerAgentsState?.possibleProducerAgents ?? [];
	}
);

// Are Possible Producer Agents Loaded Selector.
const makeArePossibleProducerAgentsLoadedSelector = () => createSelector(
	[getPossibleProducerAgentsState],
	(possibleProducerAgentsState: PossibleProducerAgentsState | undefined): boolean => {
		return possibleProducerAgentsState?.arePossibleProducerAgentsLoaded ?? false;	}
);

// Are Possible Producer Agents Loaded By Policy Producer Agency Id Selector.
const makeArePossibleProducerAgentsLoadedByPolicyProducerAgencyIdSelector = () => createSelector(
	[makeGetPossibleProducerAgentsStateByPolicyProducerAgencyIdSelector()],
	(possibleProducerAgentsState: PossibleProducerAgentsState | undefined): boolean => {
		return possibleProducerAgentsState?.arePossibleProducerAgentsLoaded ?? false;
	}
);

// Export composed methods.
export {
	getPossibleProducerAgentsState,
};

// export selectors.
export {
	makeGetPossibleProducerAgentsStateByPolicyProducerAgencyIdSelector,
	makeGetPossibleProducerAgentsSelector,
	makeGetPossibleProducerAgentsByPolicyProducerAgencyIdSelector,
	makeArePossibleProducerAgentsLoadedSelector,
	makeArePossibleProducerAgentsLoadedByPolicyProducerAgencyIdSelector,
};